import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { EncriptDecript } from '@pristinebase/Process/EncriptDecript';
import { ExcelService } from '@pristinebase/Process/excel.Service';
import { SessionManageMent } from '@pristinebase/Process/SessionManageMent';
import { WebApiHttp } from '@pristinebase/Process/WebApiHttp.services';
import { PristineToaster } from '@pristinebase/Process/ZivameServices/PristineToaster';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-vendor-notification',
  templateUrl: './vendor-notification.component.html',
  styleUrls: ['./vendor-notification.component.scss']
})
export class VendorNotificationComponent implements OnInit {

  VendorArray: any[] = [];
  FilteredVendorArray: any[] = [];

  title = new FormControl('', [Validators.required]);
  message = new FormControl('', [Validators.required]);

  constructor(
    public WebApiHttp: WebApiHttp,
    public _toasterService: PristineToaster,
    private spinner: NgxSpinnerService,
    private _router: Router,
    public fb: FormBuilder,
    public session: SessionManageMent,
    public dialog: MatDialog,
  ) { console.log(this.session) }

  ngOnInit() {
    this.getVendor();
  }


  getVendor() {
    this.spinner.show()
    this.WebApiHttp.Get(this.WebApiHttp.ApiURLArray.getAllVendorList).then(res => {
      if (res.length > 0 && res[0].condition.toLowerCase() == 'true') {
        res.forEach(ele => {

          ele.checked = false;
          this.VendorArray.push(ele)
          // console.log(this.VendorArray);
        })
        this.FilteredVendorArray = this.VendorArray
      }
      else {
        this.VendorArray = []
        this.FilteredVendorArray = []
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      this.spinner.hide()
    })
  }


  dropDownSearchFilter(value, array_name) {
    if (array_name == 'vendor') {
      if (value == '') {
        this.FilteredVendorArray = this.VendorArray
      } else {
        this.FilteredVendorArray = this.VendorArray.filter(ele => {
          return ele.vendorNo.toLowerCase().includes(value.toLowerCase())
        })
      }
    }

  }


  allSelected = false;
  toggleAllSelection(event: any) {
    this.allSelected = event.checked;
    this.FilteredVendorArray.forEach(ele => ele.checked = this.allSelected);
  }

  checkIfAllSelected() {
    this.allSelected = this.FilteredVendorArray.every(ele => ele.checked);
  }


  createNotification() {
    if (this.title.value == '' || this.title.value == undefined || this.title.value == null) {
      this._toasterService.onError("Error", "Please Enter Title.");
      return;
    }

     const selectedVendors = this.FilteredVendorArray.filter(ele => ele.checked);
    if (selectedVendors.length === 0) {
      this._toasterService.onError("Error", "Please select at least one vendor.");
      return;
    }

    if (this.message.value == '' || this.message.value == undefined || this.message.value == null) {
      this._toasterService.onError("Error", "please Enter Message.");
      return;
    }

    const json = selectedVendors.map(vendor => ({
      title: this.title.value,
      message: this.message.value,
      created_by: this.session.getEmail,
      email: vendor.vendorNo
    }));

    this.spinner.show();
    this.WebApiHttp.Post(this.WebApiHttp.ApiURLArray.NotificationCreate, json).then(
      (resut: Array<{
        condition: string;
        message: string;
      }>) => {
        if (resut.length > 0 && resut[0].condition.toLowerCase() == 'true') {
          this._toasterService.onSuccess("Success", resut[0].message);

          this.title.reset();
          this.message.reset();

          this.FilteredVendorArray.forEach(ele => (ele.checked = false));
          this.allSelected = false

        } else {
          this._toasterService.onError("Error", resut[0].message);
        }
      }
    ).catch(ee => {
      this._toasterService.onError("Error", ee.message);
      this.spinner.hide();
    }).finally(() => {
      this.spinner.hide();

    });

  }


  viewNotificationList() {
      this._router.navigate(['notification/vendor_notification_create/notification_list'])
  }


}